import React, { useState, useEffect } from 'react';
import { Grid, Typography, Box, requirePropFactory } from "@material-ui/core";
import ButtonAtom from '../../component/ButtonAtom/index.jsx'
import TextfieldAtom from '../../component/Textfield/index.jsx'
import { makeStyles } from '@material-ui/styles';
import Avatar from "@material-ui/core/Avatar";
import HomeIcon from '@mui/icons-material/Home';
import { typography } from '@mui/system';
import FooterBar from './../../component/FooterAtom/index'
import { useLocation, useHistory } from 'react-router-dom';
import firebase from "../../config/firebase/index";
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';
import DefaultImage from './../../img/chana.jpg';
import LinearProgress from '@mui/material/LinearProgress';
import ReactGA from 'react-ga';
import encSecret from '../../config/encryption/index.js';
import NoFollowMeta from '../../component/NofollowMeta/index.jsx';
var CryptoJS = require("crypto-js");

// import ToggleButton from '../../component/ToggleButton/index.jsx';


const Edit_Profile = () => {
    const classes = useStyles();
    const location = useLocation();
    const user = JSON.parse(localStorage.getItem("user"));
    const history = useHistory();
    const [name, setName] = useState(CryptoJS.AES.decrypt(user[0].Name, encSecret.key).toString(CryptoJS.enc.Utf8));
    const PhoneNo = user[0].PhoneNo;
    const [city, setCity] = useState(user[0].City);
    // const [img, setImg] = useState(user[0].image);
    const [uploadProgress, setUploadProgress] = useState("");
    const [image, setImage] = useState(user[0].image);
    const userId = location.state.userId;
    const isDealer = user[0].dealerFlag;
    // const [isToggled, setIsToggled] = useState(user[0].whatsappOptIn ? user[0].whatsappOptIn : false);
    // const [updateWAOptIn, setUpdateWAOptIn] = useState(false);
    // const whatsappOpInText = user[0].whatsappOpInText ? user[0].whatsappOpInText : "व्हाट्सएप संदेशों के लिए ऑप्ट-इन करें";

    const profileSave = (category, action, label) => {
        console.log("GA event:", category, ":", action, ":", label);
        ReactGA.event({
            category: category,
            action: action,
            label: label,
        })
    }

    const handleNameChange = (e) => {
        setName(e.target.value);
    }

    // const handlePhoneChange = (e) => {
    //     setPhoneNo(e.target.value);
    // }
    const handleCityChange = (e) => {
        setCity(e.target.value);
    }
    // const handleImgChange = (e) => {
    //     setImg(e.target.value);
    //     console.log(img);
    // }

    const updateUser = () => {
        console.log("Updating user");
        const editRef = firebase.database().ref('Users/' + userId);
        editRef.update({
            "Name": CryptoJS.AES.encrypt(name, encSecret.key).toString(),
            "PhoneNo": PhoneNo,
            "City": city,
            "img": image ? image : "",
            "updatedAt": new Date().toISOString(),
            // "optInDateTime" : updateWAOptIn && user[0].whatsappOptIn ? new Date().toISOString() : user[0].optInDateTime,
            // "optOutDateTime" : updateWAOptIn && !user[0].whatsappOptIn ? new Date().toISOString() : ""
        });
        profileSave('Edit Profile', 'Click', 'Save profile button');
        history.push("/profile");

    };

    // Upload file to firebase
    const fileUpload = (e) => {
        const file = e.target.files[0];
        const storageRef = firebase.storage();
        const uploadTask = storageRef.ref('All_Files/').child(file.name).put(file);

        uploadTask.on('state_changed',
            (snapshot) => {
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                setUploadProgress(progress)
                console.log('Upload is ' + progress + '% done');
            },
            (error) => {
                // Handle unsuccessful uploads
                console.log("error:-", error)
            },
            () => {
                // Handle successful uploads on complete
                // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                    console.log('File available at', downloadURL);
                    setImage(downloadURL)
                });
            }
        )
    }

    return (
        <Grid style={{ textAlign: "center", margin: "auto", maxWidth: 540 }}>
            <NoFollowMeta/>
            <Grid style={{margin: "20px 40px"}}>

                <Box>
                    <Typography variant="h6" style={{ fontWeight: 600 }} gutterBottom >प्रोफाइल</Typography>
                </Box>

                <Typography className={classes.border}></Typography>

                <Box mb={3} mt={3} className={`${classes.farmerImage} ${classes.iconOverImage}`}>
                    <Avatar sx={{ width: '130px', height: '130px', }} className={classes.image} alt="farmer" src={image} />
                    <Box className={classes.editCenter}>
                        <label htmlFor="icon-button-file" className={classes.centerIconImage}>
                            <AddPhotoAlternateOutlinedIcon fontSize='large' />
                        </label>
                        <input hidden accept="image/*" className={classes.input} id="icon-button-file" onChange={fileUpload} type="file" />
                    </Box>
                    {uploadProgress > 0 && uploadProgress < 100 ?
                        <LinearProgress variant="determinate" value={uploadProgress} />
                        : <></>
                    }
                    {/* <Box className={classes.editCenter}>
                        <input type="file" className={classes.editIcon} name="edit_profile" onChange={handleImgChange}/>
                        <AutoAwesomeMotionIcon className={classes.centerIconImage} />

                    </Box> */}
                </Box>

                <Box>
                    <Typography variant="h6" gutterBottom className={classes.labelAlign}>
                        आपका नाम
                    </Typography>
                    <TextfieldAtom placeholder="अपना नाम लिखे" value={name} onChange={handleNameChange} />
                </Box>

                <Box mb={3}>
                    <Typography variant="h6" gutterBottom className={classes.labelAlign}>
                        आपका व्हाट्सप्प नंबर
                    </Typography>
                    <TextfieldAtom placeholder="अपना नंबर लिखे " value={PhoneNo} disabled />
                </Box>

                <Box mb={3}>
                    <Typography variant="h6" gutterBottom className={classes.labelAlign}>
                        आपका शहर का नाम
                    </Typography>
                    <TextfieldAtom placeholder="शहर का नाम " value={city} onChange={handleCityChange} />
                </Box>
                {/* <Box className={classes.headerBrowser2}>
                    <ToggleButton rounded={true} isToggled={isToggled} onToggle={() => { setIsToggled(!isToggled); setUpdateWAOptIn(true); }} />
                    <Typography variant="h7" className={classes.textMiddleSet}>{whatsappOpInText}</Typography>
                </Box> */}


                <ButtonAtom mt={7}
                    name=" प्रोफाइल सेव करे "
                    onClick={updateUser}
                />


            </Grid>

            <Box mt={7}>
                <FooterBar isDealer = {isDealer} active={[0, 0, 0, 0]}/>
            </Box>



        </Grid>

    )
};

const useStyles = makeStyles(() => ({
    commonFullSection: {
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    },
    commonMidSection: {
        maxWidth: 540,
        background: '#fff',
        // boxShadow: '0 0 5px #eee',
        padding: 20,
        boxSizing: 'border-box',
        textAlign: 'center',
        marginTop: '-100px',
        width: 'calc(100% - 60px)',
    },
    marginTopAuto: {
        marginTop: 'auto',
    },
    labelAlign: {
        textAlign: 'left',
        marginTop: 30
    },
    purpuleColor: {
        color: '#53252f',
    },
    LastSection: {
        width: '360px',
        height: '60px',
        margin: '69px 0 0',
        padding: '9px 20px',
        boxSizing: 'border-box',
        backgroundColor: '#fff',
    },
    farmerImage: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        size: '50%',
    },
    image: {
        width: '150px',
        height: '150px',
        borderRadius: '50%',
        position: 'relative',
        overflow: 'hidden',
    },
    centerIconImage: {
        position: 'absolute',
        left: '50 %',
        top: '50 %',
        transform: 'translate(-50 %, -50 %)',
        cursor: 'pointer',
    },
    iconOverImage: {
        postion: 'relative',
    },
    border: {
        borderBottom: 'solid 1px #ddd',

    },
    editCenter: {
        position: 'absolute',
        top: '17%',
        right: '54%',
    },
    editIcon: {
        opacity: 0,
    },
    headerBrowser2: {
        background: '#fff',
        color: 'black',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
        position: 'relative',
        borderColor: '#53252f',
        '& input': {
            paddingLeft: 50,
        }
    },
    textMiddleSet: {
        marginLeft: '0px',
    },

}));

export default Edit_Profile;